<template>
  <v-card tile elevation="0" class="grey lighten-4 mt-12 mb-12">
    <v-card-text class="text-left">
      <v-row justify="center" align="center" no-gutters>
        <v-col cols="12" md="3"
          ><Entry>{{ $cms.get(content, 'entry_text_1') }}</Entry></v-col
        >
        <v-col cols="12" md="3"
          ><Entry>{{ $cms.get(content, 'entry_text_2') }}</Entry></v-col
        >
      </v-row>
      <v-row no-gutters justify="center" align="center" class="pt-md-3 pb-md-3">
        <v-col cols="12" md="3"
          ><Entry>{{ $cms.get(content, 'entry_text_3') }}</Entry></v-col
        >
        <v-col cols="12" md="3"
          ><Entry>{{ $cms.get(content, 'entry_text_4') }}</Entry></v-col
        >
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Entry from '@/components/savings/entry/Entry.vue'
import entriesJSON from '@/data/json/homepage/savings/entries.json'
export default {
  components: {
    Entry
  },
  data() {
    return {
      content: entriesJSON.data
    }
  }
}
</script>

<style lang="scss" scoped></style>
